// extracted by mini-css-extract-plugin
export default {"sib-form":"XFCh1fpiNi_jr6Z2QGGm","sib-form-row":"wmWQOwEWhmvCH5QLOkKd","sib-form--item":"DPfMZHDmWP_EFSLjOzhQ","sib-form-column":"YsicRiESsmGDSDW9LuOH"};